<template>
  <div>
    <v-toolbar
      flat
      color="white"
    >
      <v-text-field
        v-model="search"
        prepend-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog
        v-model="dialog"
        max-width="700px"
        scrollable
      >
        <v-btn
          slot="activator"
          icon
        >
          <v-icon>add_circle_outline</v-icon>
        </v-btn>
        <v-card>
          <v-toolbar
            card
            dense
            color="transperant"
          >
            <v-btn
              icon
              @click.native="close"
            >
              <v-icon>reply</v-icon>
            </v-btn>

            <!-- <v-toolbar-title><h4>Details</h4></v-toolbar-title> -->
            <v-btn
              icon
              @click.native="saveAndClose"
            >
              <v-icon>library_add</v-icon>
            </v-btn>

            <v-btn
              icon
              @click.native="save"
            >
              <v-icon>save</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="add"
            >
              <v-icon>add</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="deleterow"
            >
              <v-icon>delete</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="first"
            >
              <v-icon>first_page</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="next"
            >
              <v-icon>keyboard_arrow_left</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="previous"
            >
              <v-icon>keyboard_arrow_right</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="last"
            >
              <v-icon>last_page</v-icon>
            </v-btn>
            <v-menu
              bottom
              left
            >
              <v-btn
                slot="activator"
                icon
              >
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="(item, i) in items"
                  :key="i"
                  click
                >
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>

          </v-toolbar>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-form
              v-model="editedItem.valid"
              ref="form"
              lazy-validation
            >
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm12
                  >
                    <v-text-field
                      v-model="editedItem.codeNO"
                      label="CodeNo"
                      :rules="editedItem.codeRules"
                      required
                      prepend-icon="select_all"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                  >
                    <v-autocomplete                      
                      hint="Atleast 3 Characters required"                      
                      :loading="loader"
                      chips                      
                      flat
                      placeholder="Select only suggested Country"
                      :items="countryItems"
                      v-model="editedItem.countryID"
                      prepend-icon="assistant"
                      label="Country"
                      color="blue"
                      item-text="name"
                      item-value="countryID"
                      @change="stateSelect"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                  >
                    <v-autocomplete                      
                      hint="Atleast 3 Characters required"                      
                      :loading="loader"
                      chips                     
                      flat
                      placeholder="Select only suggested State"
                      :items="filterStateItems"
                      v-model="editedItem.stateID"
                      prepend-icon="assistant"
                      label="State"
                      color="blue"
                      item-text="name"
                      item-value="stateID"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                  >
                    <v-textarea
                      v-model="editedItem.description"
                      label="Description"
                      prepend-icon="description"
                    >
                      <div slot="label">
                        Description
                      </div>
                    </v-textarea>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                  >
                    <v-autocomplete                     
                      hint="Atleast 3 Characters required"
                      placeholder="Select only suggested shift"                                              
                      :items="shiftItems"
                      v-model="editedItem.shiftID"
                      prepend-icon="select_all"
                      label="Shift"
                      color="blue"
                      item-text="name"
                      item-value="shiftID"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                  >
                    <p>
                      Weekly Work Day
                    </p>
                  </v-flex>
                  <v-flex
                    lg2
                    sm2
                  >
                    <v-checkbox
                      label="MON"
                      v-model="editedItem.isMon"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    lg2
                    sm2
                  >
                    <v-checkbox
                      label="TUE"
                      v-model="editedItem.isTue"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    lg2
                    sm2
                  >
                    <v-checkbox
                      label="WED"
                      v-model="editedItem.isWed"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    lg2
                    sm2
                  >
                    <v-checkbox
                      label="THUR"
                      v-model="editedItem.isThur"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    lg2
                    sm2
                  >
                    <v-checkbox
                      label="FRI"
                      v-model="editedItem.isFri"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    lg2
                    sm2
                  >
                    <v-checkbox
                      label="SAT"
                      v-model="editedItem.isSat"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    lg2
                    sm2
                  >
                    <v-checkbox
                      label="SUN"
                      v-model="editedItem.isSun"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                  >
                    <v-textarea
                      v-model="editedItem.reference"
                      label="Reference"
                      prepend-icon="description"
                    >
                      <div slot="label">
                        Reference
                      </div>
                    </v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <delete-confirmation-dialog
            ref="formdeleteConfirmationDialog"
            heading="Are You Sure You Want To Delete?"
            message="Are You Sure You Want To Delete This Item Permanently?"
            @onConfirm="formDeleteItem"
          >
          </delete-confirmation-dialog>

        </v-card>
      </v-dialog>
    </v-toolbar>
    <app-section-loader :status="loader"></app-section-loader>
    <v-data-table
      :headers="headers"
      :items="gridItems"
      :search="search"
      class="elevation-1"
      default-sort="workDateID:desc"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td class="text-xs-left">{{ props.item.codeNO}}</td>
        <!-- <td class="text-xs-left">{{ props.item.countryId }}</td> -->
        <td class="text-xs-left">{{ props.item.countryName}}</td>
        <td class="text-xs-left">{{ props.item.stateName}}</td>
        <td class="text-xs-left">{{ props.item.addedByUser }}</td>
        <td class="text-xs-left">{{ props.item.modifiedByUser }}</td>
        <td class="text-xs-left">{{ props.item.modifiedDate | formatDate}}</td>

        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="onDeleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template slot="no-data">
        <v-btn
          color="primary"
          outline
          @click="initialize"
        > Record not exist.Refresh again in while time.</v-btn>
      </template>
    </v-data-table>
    <v-snackbar
      :top="y === 'top'"
      :timeout="timeout"
      v-model="snackbar"
    >
      {{ snackbarMessage }}
    </v-snackbar>
    <delete-confirmation-dialog
      ref="deleteConfirmationDialog"
      heading="Are You Sure You Want To Delete?"
      message="Are You Sure You Want To Delete This Item Permanently?"
      @onConfirm="deleteItem"
    >
    </delete-confirmation-dialog>
  </div>
</template>
 
<script>
import { getStates, getCountries, getShiftMasters, getCompanyWorkDayMasters, getCompanyWorkDayMaster, createCompanyWorkDayMaster, updateCompanyWorkDayMaster, deleteCompanyWorkDayMaster } from '@/api/workDayMaster';
import GlobalMessage from '@/constant'
export default {
  components: {

  },
  data: () => ({
    dialog: false,
    loader: false,
    search: '',
    statusOptions: [
      { text: 'Active', value: 1 },
      { text: 'InActive', value: 2 }
    ],
    snackbar: false,
    snackbarMessage: '',
    timeout: 2000,
    y: 'top',
    headers: [
      { text: 'Code', value: 'codeNO', align: 'left' },
      { text: 'Country', value: 'countryID', align: 'left' },
      { text: 'State', value: 'stateID', align: 'left' },
      { text: 'Added By', value: 'Added', align: 'left' },
      { text: 'Modified By', value: 'Modifiedby', align: 'left' },
      { text: 'Modified Date', value: 'ModifiedDate', align: 'left' },
      { text: 'Actions', value: 'name', sortable: false, align: 'left' }
    ],
    countryItems: [],
    stateItems: [],
    shiftItems: [],
    filterStateItems: [],
    gridItems: [],
    editedIndex: -1,
    selectedItem: null,
    editedItem: {
      valid: false,
      workDateID: -1,
      stateID: -1,
      shiftID: null,
      workdayShiftID: null,
      codeRules: [v => !!v || 'Code is required'],
      codeNO: '',
      countryID: -1,
      isMon: true,
      isTue: true,
      isWed: true,
      isThur: true,
      isFri: true,
      isSat: true,
      isSun: true,
      addedByUserID: null,
      addedDate: new Date(),
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: null,
      modifiedDate: new Date()
    },
    defaultItem: {
      valid: false,
      workDateID: -1,
      stateID: -1,
      shiftID: null,
      workdayShiftID: null,
      codeRules: [v => !!v || 'Code is required'],
      codeNO: '',
      countryID: 1,
      isMon: true,
      isTue: true,
      isWed: true,
      isThur: true,
      isFri: true,
      isSat: true,
      isSun: true,
      addedByUserID: null,
      addedDate: new Date(),
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: null,
      modifiedDate: new Date()
    },
    searchItem: { action: '', Id: null, searchString: 'searchString', },
    items: [
      { title: 'Clear Items' },
      { title: 'Post' },
      { title: 'Delete' },
      { title: 'Print' }
    ],
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Add WorkDay' : 'Edit WorkDay';
    }
  },

  watch: {
    dialog (val) {
      val || this.close();
    }
  },

  created () {
    this.initialize();
  },

  methods: {
    initialize () {
      this.loader = true;
      getCompanyWorkDayMasters('')
        .then(response1 => {
          this.gridItems = response1.data;
          this.loader = false;
          console.log(this.gridItems);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      getStates('')
        .then(response2 => {
          this.stateItems = response2.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      getCountries('')
        .then(response3 => {
          this.countryItems = response3.data;
          this.loader = false;
          //this.total = response.data.length;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      getShiftMasters('')
        .then(response4 => {
          this.shiftItems = response4.data;
          this.loader = false;
          console.log(this.shiftItems);
          //this.total = response.data.length;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    editItem (item) {
      this.editedIndex = this.gridItems.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dialog = true;
    },
    onDeleteItem (item) {
      this.$refs.deleteConfirmationDialog.openDialog();
      this.selectedItem = item;
    },
    deleteItem () {
      this.$refs.deleteConfirmationDialog.close();
      this.loader = true;
      let index = this.gridItems.indexOf(this.selectedItem);
      deleteCompanyWorkDayMaster(this.selectedItem)
        .then(() => {
          this.loader = false;
          this.selectedItem = null;
          this.gridItems.splice(index, 1);
         window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    saveAndClose () {
      this.save();
      this.close();
    },
    toolfunction () {

      getCompanyWorkDayMaster(this.searchItem)
        .then(response => {

          if (response.data.stateID != null) {

            this.editedItem = response.data;
            let index = this.gridItems.map(item => item.workDateID).indexOf(response.data.workDateID)
            this.editedIndex = index;

          }
          else {
           window.getApp.$emit('APP_API_SUCCESS', 'No more Record to view');
          }

        })
        .catch(error => {
          // this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    first () {
      this.searchItem.action = 'First';
      this.searchItem.Id = this.editedItem.workDateID;
      // this.selectedItem.searchString = 'first';
      this.toolfunction();
    },
    last () {
      this.searchItem.action = 'Last';
      this.searchItem.Id = this.editedItem.workDateID;
      //this.selectedItem.searchString = 'last';

      this.toolfunction();
    },
    previous () {
      this.searchItem.action = 'Previous';
      this.searchItem.Id = this.editedItem.workDateID;
      //this.selectedItem.searchString = 'previous';
      this.toolfunction();
    },
    next () {
      this.searchItem.action = 'Next';
      this.searchItem.Id = this.editedItem.workDateID;
      // this.selectedItem.searchString = 'next';
      this.toolfunction();
    },
    add () {

      // 
      this.editedItem=this.defaultItem;
      this.editedItem.addedByUserID = this.$store.state.auth.userId;
      this.editedItem.addedDate = new Date();
      this.editedItem.statusCodeID = 1;
      this.editedItem.statusCode = 'Active';
      this.editedItem.modifiedByUserID = this.$store.state.auth.userId;
      this.editedItem.modifiedDate = new Date();
      this.editedIndex = -1;
      console.log(editedItem);
    },
    deleterow () {
      this.$refs.formdeleteConfirmationDialog.openDialog();
    },
    formDeleteItem () {
      this.$refs.formdeleteConfirmationDialog.close();
      // this.loader = true;
      let index = this.editedIndex;

      deleteCompanyWorkDayMaster(this.editedItem.workDateID)
        .then(() => {
          //this.loader = false;
          //this.editedItem = null;
          this.add();
          this.gridItems.splice(index, 1);
        window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          //this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    close () {
      this.dialog = false;
      this.initialize();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    stateSelect (value) {
      // this.filterStateItems.index = -1;
      let uom = this.stateItems.filter(o => o.countryID == value);
      this.filterStateItems = uom;
    },
    save () {
      if (this.$refs.form.validate()) {
        this.loader = true;
        let index = this.editedIndex;
        if (this.editedIndex > -1) {
          Object.assign(this.gridItems[this.editedIndex], this.editedItem);
          this.editedItem.modifiedByUserID = this.$store.state.auth.userId;
          this.editedItem.modifiedDate = new Date();
          this.editedItem.addedByUserID = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          updateCompanyWorkDayMaster(this.editedItem)
            .then(response => {
              Object.assign(this.gridItems[index], response.data);
              this.loader = false;
             window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.UPDATE);
            })
            .catch(error => {
              this.loader = false;
             window.getApp.$emit('APP_API_ERROR', error);
            });
        } else {
          this.editedItem.workDateID = parseInt(Math.random() * 100) + 1024; // mock a id
         //this.editedItem.workdayShiftID = null;
          this.editedItem.AddedByUserID = this.$store.state.auth.userId;
          this.editedItem.AddedDate = new Date();
          this.editedItem.StatusCodeID = 1;
          createCompanyWorkDayMaster(this.editedItem)
            .then(response => {
              this.gridItems.push(response.data);
              this.loader = false;              
              this.editedItem = response.data;
              let index = this.gridItems.map(item => item.workDateID).indexOf(response.data.workDateID)
              this.editedIndex = index;
              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        }
        //this.close();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/calendar/WorkDay.vue